import React from "react";
import { Columns, Column } from "@origin-digital/ods-core";

interface ResponsiveColumnProps {
  children: React.ReactNode;
  width?:
    | "3/4"
    | "content"
    | "1/2"
    | "1/3"
    | "2/3"
    | "1/4"
    | "1/6"
    | "5/6"
    | "1/12"
    | "5/12"
    | "7/12"
    | "11/12"
    | "flex";
  collapseBelow?: "sm" | "md" | "lg" | "xl";
}

const ResponsiveColumn: React.FC<ResponsiveColumnProps> = ({
  children,
  width = "3/4",
  collapseBelow = "md",
}) => (
  <Columns collapseBelow={collapseBelow}>
    <Column width={width}>{children}</Column>
  </Columns>
);

export default ResponsiveColumn;
